<template>
  <SectionMushroomNewBuilderBanner/>
<SectionMushroomNewBuilderHeader/>
<SectionMushroomNewBuilderHero/>
<SectionMushroomNewBuilderTestimonial/>
<SectionMushroomNewBuilderLogoSwiper/>
<SectionMushroomNewBuilderDescriptionWithIcons/>
<SectionMushroomNewBuilderContentWithLeftImages/>
<SectionMushroomNewBuilderIconsWithImagesSwiper/>
<SectionMushroomNewBuilderTitleDescriptionIcons/>
<!-- <SectionMushroomNewBuilderTitleDescriptionsPrice/> -->
<SectionMushroomNewBuilderTitleDescriptionsPriceDup :mainHeading="saleText" :subscriptionOverlay="false" :productHandle="'cognition-real-mushroom-coffee-subscription'"/>
<SectionMushroomNewBuilderTableWithCheckbox/>
<SectionMushroomNewBuilderFrequentlyQuestions/>
<SectionMushroomNewBuilderReviews/>
<SectionLifeboostLatteBuilderFDA/>
<SectionMushroomNewBuilderFooter/>
</template>

<script setup>
useSeoMeta({
  layout: () => "default",
  title: () => "Mushroom",
  description: () => "Discover Lifeboost Cognition Coffee, a unique blend of organic, low-acid coffee infused with Lion's Mane and Chaga mushrooms. This combination is designed to enhance focus, mental clarity, and overall well-being. Enjoy clean, jitter-free energy with every cup. Special discounts and subscription options available.",
})

const { getSaleTextAndVisibility } = useTimeBasedContent();
const { text: saleText } = getSaleTextAndVisibility();


useHead({
  htmlAttrs: {
    class: 'page-real-mushroom-coffee'
  },
  bodyAttrs: {
    class: 'page-real-mushroom-coffee'
  }
})

</script>


<style lang="postcss">

html.page-real-mushroom-coffee {
  @apply 2xl:text-base xl:text-15 lg:text-sm md:text-sm sm:text-base text-12
}

body.page-real-mushroom-coffee {
  font-size: 17px;
  font-family: 'wigrum-medium';
}
</style>